import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21dada4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sub-title" }

import { computed, ref, watch, inject } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import FieldValidationFreeTextArea from "../ui/inputs/field-validation-free-text-area.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { DiarySync } from "@/enums/diary/DiarySync";
import { GoogleOAuthScope } from "@/enums/diary/GoogleOAuthScope";
import displayInfoToast from "@/alerts/infoToastAlert";


export default /*#__PURE__*/_defineComponent({
  __name: 'diary-authentication-modal',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the user.
   * @type {number}
   * @required
   */
  userId: {
    type: Number,
    required: true,
  },
  /**
   * The sync type determines which modals will be displayed.
   * @type {number}
   * @required
   */
  diarySyncType: {
    type: Number,
    required: true,
  },
},
  emits: ["update:modelValue", "modalClosed"],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  async (value) => {
    if (!value) {
      return;
    }

    authCode.value = "";
    authURL.value = "";

    if (props.diarySyncType == DiarySync.Office365Calender) {
      await fetchMicrosoftAuthURL();
    } else if (props.diarySyncType == DiarySync.GoogleCalender) {
      await fetchGoogleAuthURL();
    }

    if (authURL.value) {
      window.open(authURL.value);
    }
  },
);

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acqauintApiNextClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const authCode = ref("");
const accessToken = ref("");
const authURL = ref("");

const fetchMicrosoftAuthURL = async () => {
  try {
    authURL.value = await acquaintApiClient.httpGet("app/office/AuthUrl");
  } catch (err) {
    displayErrorMessage("Authentication failed. Please try again.");
    authURL.value = "";
  }
};

const onAuthoriseClick = async () => {
  if (props.diarySyncType == DiarySync.Office365Calender) {
    await fetchMicrosoftAccessToken();
  } else if (props.diarySyncType == DiarySync.GoogleCalender) {
    await fetchGoogleAccessToken();
  }

  if (accessToken.value) {
    displayInfoToast(
      "Authentication complete. Appointments will start syncing to your calendar shortly.",
    );
    emit("modalClosed", true);
    showModal.value = false;
  }
};

const fetchMicrosoftAccessToken = async () => {
  try {
    accessToken.value = await acquaintApiClient.httpPost(
      `app/office/${props.userId}/AccessToken`,
      authCode.value,
    );
  } catch (err) {
    displayErrorMessage("Authentication failed. Please try again.");
    accessToken.value = "";
  }
};

const fetchGoogleAuthURL = async () => {
  try {
    authURL.value = await acqauintApiNextClient.httpGet(
      `OAuth/AuthUrl?scopes=${GoogleOAuthScope.CalendarEvents}&scopes=${GoogleOAuthScope.CalendarReadOnly}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    authURL.value = "";
  }
};

const fetchGoogleAccessToken = async () => {
  try {
    accessToken.value = await acqauintApiNextClient.httpPost(
      `OAuth/${props.userId}/AccessToken`,
      authCode.value,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    accessToken.value = "";
  }
};

const onCancelClick = () => (showModal.value = false);

const modalTitle = computed(() => accountType.value + " Authorisation");

const accountType = computed(() => {
  switch (props.diarySyncType) {
    case DiarySync.Office365Calender:
      return "Office 365 Calendar";
    case DiarySync.GoogleCalender:
      return "Google Calendar";
    default:
      return "Calendar";
  }
});

const modalClosed = async () => {
  emit("modalClosed", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    title: modalTitle.value,
    height: "320px",
    onModalClosed: modalClosed
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, " A tab will open, prompting you to login to your " + _toDisplayString(accountType.value) + " account. Once you complete the authentication process, please copy the Auth Code into the box and click the Authorise button. ", 1),
      _createVNode(FieldValidationFreeTextArea, {
        label: "Auth Code",
        modelValue: authCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((authCode).value = $event)),
        height: "7rem",
        "read-only": authURL.value == '',
        valueChangeEvent: _unref(TextboxValueChangeEvent).KeyUp
      }, null, 8, ["modelValue", "read-only", "valueChangeEvent"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        disabled: authCode.value == '',
        options: {
          text: 'Authorise',
          onClick: () => {
            onAuthoriseClick();
          },
        }
      }, null, 8, ["disabled", "options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})